"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.GAME_STATUS_SERVICE_PATHS = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _GenericStore2 = _interopRequireDefault(require("../../../../KESI2/Stores/GenericStore"));

var _RoundService = _interopRequireDefault(require("./RoundService"));

var _RoundObject = _interopRequireWildcard(require("./POJOS/RoundObject"));

var _QuestionService = _interopRequireDefault(require("./QuestionService"));

var _GameObject = _interopRequireDefault(require("./POJOS/GameObject"));

var _QuestionSetService = _interopRequireDefault(require("./QuestionSetService"));

var _QuestionSetStatus = _interopRequireDefault(require("./POJOS/QuestionSetStatus"));

var _HighscoreService = _interopRequireDefault(require("./HighscoreService"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _QuestionStatus = _interopRequireDefault(require("./POJOS/QuestionStatus"));

var _QuizHelper = _interopRequireDefault(require("./QuizHelper"));

var _AnswerStatus = _interopRequireDefault(require("./POJOS/AnswerStatus"));

var _AlertHelper = require("../../../../helpers/AlertHelper");

var _MessageHelper = _interopRequireDefault(require("../../../../helpers/MessageHelper"));

var _QuizService = require("./QuizService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var GAME_STATUSES = {
  OPEN: 'open',
  COMPLETED: 'completed',
  FUTURE: 'future',
  MISSED: 'missed'
};
var GAME_STATUS_SERVICE_PATHS = {
  IS_TRAINING: 'isTraining',
  INITIALIZED: 'initialized',
  LEVEL_AVAILABLE: 'levelAvailable',
  SET_ID: 'setId',
  GAME_HIGHSCORES: 'gameHighscores',
  GAME_RANK: 'gameRank',
  CURRENT_LEVEL_HIGHSCORES: 'currentLevelHighscores',
  LEVEL_HIGHSCORES: 'levelHighscores',
  DIFF_TO_FIRST_RANK: 'diffToFirstRank',
  DIFF_TO_NEXT_RANK: 'diffToNextRank',
  LEVEL_POINTS: 'levelPoints',
  CURRENT_QUESTION_SET_RANK: 'currentQuestionSetRank',
  USER: 'user',
  LEVEL_NAME: 'levelName',
  HISTORY: 'history'
};
/* const ANSWER_SOLUTION_STATUS = {
  SELECTED_CORRECT: 'selectedCorrect',
  UNSELECTED_CORRECT: 'unselectedCorrect',
  SELECTED_INCORRECT: 'selectedIncorrect',
  UNSELECTED_INCORRECT: 'unselectedIncorrect',
}; */

exports.GAME_STATUS_SERVICE_PATHS = GAME_STATUS_SERVICE_PATHS;
var NUMBER_OF_PRELOADED_ROUNDS_MAX = 20;
var NUMBER_OF_PRELOADED_ROUNDS_MIN = 15;
var LEVEL_STATUSES = {
  OPEN: 'open',
  COMPLETED: 'completed',
  FUTURE: 'future',
  MISSED: 'missed'
};

var GamestatusService = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(GamestatusService, _GenericStore);

  var _super = _createSuper(GamestatusService);

  function GamestatusService() {
    var _this;

    (0, _classCallCheck2["default"])(this, GamestatusService);
    _this = _super.call(this);
    _this.state = {};
    _this.isLoading = false;
    _this.nextRoundAvailable = false;
    _this.noLevelAvailable = false;
    _this.game = null;
    _this.globalGame = null;
    _this.user = null;
    _this.isInitialized = false;
    return _this;
  }

  (0, _createClass2["default"])(GamestatusService, [{
    key: "initialState",
    value: function initialState() {
      return {
        user: {},
        isTraining: false,
        initialized: false
      };
    }
  }, {
    key: "getUser",
    value: function getUser() {
      return this.user;
    }
  }, {
    key: "preloadRoundsAndQuestions",
    value: function () {
      var _preloadRoundsAndQuestions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(game, levelId, start, limit, showInternetMissingError) {
        var _this2 = this;

        var roundIds, roundNumber, round, reqFn;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _RoundService["default"].preload(levelId, start, limit, showInternetMissingError);

              case 3:
                roundIds = [];

                for (roundNumber = start; roundNumber < start + limit; roundNumber++) {
                  round = _RoundService["default"].getByLevelAndNumber(levelId, roundNumber);

                  if (round != null) {
                    // noinspection Eslint (reason: used of global game object)
                    game.sets[levelId].rounds[roundNumber] = new _RoundObject["default"](round.emsId, round.percentageCorrect, round.questions); // eslint-disable-line

                    roundIds.push(round.emsId);
                  }
                }

                reqFn = /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(from) {
                    var questionsToRequest;
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(from > roundIds.length)) {
                              _context.next = 4;
                              break;
                            }

                            console.log('all questions loaded');

                            _this2.setValue(GAME_STATUS_SERVICE_PATHS.INITIALIZED, true);

                            return _context.abrupt("return");

                          case 4:
                            questionsToRequest = roundIds.slice(from, from + 5);
                            console.log("going to request questions from round ".concat(String(from), ": ").concat((0, _stringify["default"])(questionsToRequest)));
                            _context.next = 8;
                            return _QuestionService["default"].requestQuestionsFromServerForRounds(questionsToRequest);

                          case 8:
                            console.log('questions loaded');
                            reqFn(from + 5);

                          case 10:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function reqFn(_x6) {
                    return _ref.apply(this, arguments);
                  };
                }();

                reqFn(0);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.log('error loading rounds and questions', _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      function preloadRoundsAndQuestions(_x, _x2, _x3, _x4, _x5) {
        return _preloadRoundsAndQuestions.apply(this, arguments);
      }

      return preloadRoundsAndQuestions;
    }()
  }, {
    key: "initGame",
    value: function () {
      var _initGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(user) {
        var _this3 = this;

        var stateObj, questionSet, levelId, levelName, isTraining, setStatus, gameHighscore, levelHighscores, currentRound;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setValue(GAME_STATUS_SERVICE_PATHS.INITIALIZED, false);
                stateObj = {};

                if (!this.game) {
                  this.game = new _GameObject["default"]();
                }

                if (!this.globalGame) {
                  this.globalGame = this.game;
                }

                _context3.prev = 4;
                _context3.next = 7;
                return _QuestionSetService["default"].preloadCurrentLevel(user);

              case 7:
                questionSet = _context3.sent;

                if (!(questionSet == null)) {
                  _context3.next = 15;
                  break;
                }

                this.noLevelAvailable = true;
                stateObj[GAME_STATUS_SERVICE_PATHS.LEVEL_AVAILABLE] = false;
                stateObj[GAME_STATUS_SERVICE_PATHS.INITIALIZED] = true;
                this.isInitialized = true;
                this.setValues(stateObj);
                return _context3.abrupt("return");

              case 15:
                this.noLevelAvailable = false;
                stateObj[GAME_STATUS_SERVICE_PATHS.LEVEL_AVAILABLE] = true;
                levelId = questionSet.emsId;
                levelName = questionSet.name;
                isTraining = questionSet.isTraining; // noinspection UnnecessaryLocalVariableJS

                setStatus = new _QuestionSetStatus["default"](levelId, levelName, 0, LEVEL_STATUSES.OPEN, isTraining);
                this.game.sets[levelId] = setStatus;
                this.game.currentSetId = levelId;
                stateObj[GAME_STATUS_SERVICE_PATHS.SET_ID] = levelId;
                _context3.next = 26;
                return _HighscoreService["default"].preloadGameHighscore();

              case 26:
                gameHighscore = _context3.sent;

                if (gameHighscore != null) {
                  stateObj[GAME_STATUS_SERVICE_PATHS.GAME_HIGHSCORES] = gameHighscore.highscore;
                  gameHighscore.highscore.some(function (score) {
                    if (score.username === _this3.user.userName) {
                      stateObj[GAME_STATUS_SERVICE_PATHS.GAME_RANK] = score.rank;
                    }

                    return score;
                  });
                }

                _context3.next = 30;
                return (0, _TimeoutHelper.timeout)(500);

              case 30:
                _context3.next = 32;
                return _HighscoreService["default"].preloadLevelHighscores();

              case 32:
                levelHighscores = _context3.sent;

                if (levelHighscores != null) {
                  levelHighscores.some(function (level) {
                    if (level.value.level === questionSet.emsId) {
                      stateObj[GAME_STATUS_SERVICE_PATHS.CURRENT_LEVEL_HIGHSCORES] = level.value.highscore;
                      level.value.highscore.currentLevelHighscores.some(function (highscore) {
                        if (highscore.username === _this3.user.userName) {
                          stateObj[GAME_STATUS_SERVICE_PATHS.LEVEL_POINTS] = highscore.points;
                          var rank = highscore.rank;
                          stateObj[GAME_STATUS_SERVICE_PATHS.CURRENT_QUESTION_SET_RANK] = rank;
                          var highscoreList = level.value.highscore;

                          if (rank === 1) {
                            stateObj[GAME_STATUS_SERVICE_PATHS.DIFF_TO_FIRST_RANK] = 0;
                            stateObj[GAME_STATUS_SERVICE_PATHS.DIFF_TO_NEXT_RANK] = 0;
                          } else if (rank > 1) {
                            stateObj[GAME_STATUS_SERVICE_PATHS.DIFF_TO_FIRST_RANK] = highscoreList[0].points - highscoreList[rank - 1].points;
                            stateObj[GAME_STATUS_SERVICE_PATHS.DIFF_TO_NEXT_RANK] = highscoreList[rank - 2].points - highscoreList[rank - 1].points;
                          } else {
                            stateObj[GAME_STATUS_SERVICE_PATHS.DIFF_TO_FIRST_RANK] = 0;
                            stateObj[GAME_STATUS_SERVICE_PATHS.DIFF_TO_NEXT_RANK] = 0;
                          }
                        }

                        return highscore;
                      });
                    }

                    return level;
                  });
                }

                _context3.next = 36;
                return (0, _TimeoutHelper.timeout)();

              case 36:
                currentRound = _HighscoreService["default"].getPlayedRoundsInLevel(levelId);
                console.log('AAAAAAA - requesting 1st round');
                this.preloadRoundsAndQuestions(this.game, levelId, currentRound, 1, true, function () {
                  console.log('BBBB - Set game initialized');
                  _this3.nextRoundAvailable = true;
                  console.log('AAAAAAA - requesting other rounds');

                  _this3.preloadRoundsAndQuestions(_this3.globalGame, levelId, currentRound + 1, NUMBER_OF_PRELOADED_ROUNDS_MAX - 1, false);
                });
                _context3.next = 44;
                break;

              case 41:
                _context3.prev = 41;
                _context3.t0 = _context3["catch"](4);
                console.log(_context3.t0);

              case 44:
                this.setValues(stateObj);

              case 45:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 41]]);
      }));

      function initGame(_x7) {
        return _initGame.apply(this, arguments);
      }

      return initGame;
    }()
  }, {
    key: "isLevelAvailable",
    value: function isLevelAvailable() {
      return !this.noLevelAvailable;
    }
  }, {
    key: "initRound",
    value: function () {
      var _initRound = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(roundStatus, finishedCallback) {
        var questions;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('initRound');
                this.isLoading = true;
                _context4.prev = 2;
                _context4.next = 5;
                return _QuestionService["default"].preload(roundStatus.roundId);

              case 5:
                questions = _context4.sent;
                questions.forEach(function (question) {
                  if (!question.value) {
                    throw new Error('something expected is not defined question.value');
                  }

                  var questionValue = question.value;
                  var questionStatus = new _QuestionStatus["default"](questionValue.questionType === _QuizHelper["default"].MULTIPLE_CHOICE_KEY, _QuizHelper["default"].getPoints(questionValue), questionValue.text);
                  questionValue.answers.forEach(function (answer) {
                    // if (!answer.emsId || !answer.hasOwnProperty('correct') || !answer.text) {
                    if (!answer.emsId || !Object.prototype.hasOwnProperty.call(answer, 'correct') || !answer.text) {
                      throw new Error('something expected is not defined answer.emsId');
                    }

                    questionStatus.answers.push(new _AnswerStatus["default"](questionStatus, answer.emsId, answer.correct, answer.text));
                  });
                  roundStatus.addQuestion(questionValue.emsId, questionStatus);
                });
                this.nextRoundAvailable = true;
                this.isLoading = false;

                if (finishedCallback) {
                  finishedCallback();
                }

                _context4.next = 17;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);
                this.nextRoundAvailable = false;
                this.isLoading = false;

                if (finishedCallback) {
                  finishedCallback();
                }

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 12]]);
      }));

      function initRound(_x8, _x9) {
        return _initRound.apply(this, arguments);
      }

      return initRound;
    }()
  }, {
    key: "initNextRound",
    value: function initNextRound(finishedCallback) {
      var startGame = this.getNextRoundParams();
      var nextLevelStatus = this.getStatusForQuestionSet(startGame.setId);
      var nextRoundStatus = nextLevelStatus.rounds[startGame.roundNumber];
      nextLevelStatus.currentRound = startGame.roundNumber;
      var remainingRounds = nextLevelStatus.numberOfRemainingRounds();
      console.log("FFFFF - remaining: ".concat(String(nextLevelStatus.numberOfRemainingRounds())));

      if (remainingRounds < NUMBER_OF_PRELOADED_ROUNDS_MIN) {
        console.log("FFFFFF - requesting next rounds because there are too few left (".concat(String(remainingRounds), ")"));
        this.preloadRoundsAndQuestions(this.globalGame, nextLevelStatus.levelId, nextLevelStatus.roundCount() + nextLevelStatus.minLoadedRoundNumber(), NUMBER_OF_PRELOADED_ROUNDS_MAX - remainingRounds, remainingRounds === 0, function () {
          console.log("number of remaining rounds after loading: ".concat(String(nextLevelStatus.numberOfRemainingRounds())));

          if (nextLevelStatus.numberOfRemainingRounds() < 1) {
            (0, _AlertHelper.showWideAlertHtml)(_MessageHelper["default"].noMoreRoundsText);
          }
        });
      }

      if (remainingRounds > 0) {
        return this.initRound(nextRoundStatus, finishedCallback);
      }

      return null;
    }
  }, {
    key: "getPreviousRoundParams",
    value: function getPreviousRoundParams() {
      var gameStatus = this.getGameStatus();
      return {
        setId: gameStatus.currentSetId,
        roundNumber: gameStatus.getCurrentQuestionSet().currentRound
      };
    }
  }, {
    key: "getNextRoundParams",
    value: function getNextRoundParams() {
      if (!this.noLevelAvailable) {
        var gameStatus = this.getGameStatus();

        if (gameStatus != null) {
          return {
            setId: gameStatus.currentSetId,
            roundNumber: gameStatus.getCurrentQuestionSet().nextRound,
            questionNumber: 0,
            isAvailable: gameStatus.getCurrentQuestionSet().numberOfRemainingRounds() > 0
          };
        }
      }

      return null;
    }
  }, {
    key: "getGameStatus",
    value: function getGameStatus() {
      return this.globalGame;
    }
  }, {
    key: "getGameStatuses",
    value: function getGameStatuses() {
      return GAME_STATUSES;
    }
  }, {
    key: "getQuestionSetStatuses",
    value: function getQuestionSetStatuses() {
      return LEVEL_STATUSES;
    }
  }, {
    key: "getStatusForQuestionSet",
    value: function getStatusForQuestionSet(setId) {
      return this.getGameStatus().sets[setId];
    }
  }, {
    key: "getRoundStatus",
    value: function getRoundStatus(setId, roundNumber) {
      return this.getGameStatus().sets[setId].rounds[roundNumber];
    }
  }, {
    key: "getQuestionStatus",
    value: function getQuestionStatus(setId, roundNumber, questionNumber) {
      return this.getRoundStatus(setId, roundNumber).getQuestion(questionNumber);
    }
  }, {
    key: "isLastQuestionInRound",
    value: function isLastQuestionInRound(setId, roundNumber, questionNumber) {
      var round = this.getGameStatus().getQuestionSet(setId).rounds[roundNumber];
      return questionNumber + 1 >= round.getQuestionCount();
    }
  }, {
    key: "getChosenAnswers",
    value: function getChosenAnswers(setId, roundId, questionId) {
      var set = this.getGameStatus().sets[setId];
      var round = set.rounds[roundId];
      var question = round.getQuestion(questionId);
      var checkedAnswers = [];
      var i = -1; // for (const answer of question.answers) {

      question.answers.forEach(function (answer) {
        i += 1;

        if (answer.checked) {
          checkedAnswers.push({
            displayPosition: i,
            emsId: answer.emsId
          });
        }
      });
      return checkedAnswers;
    }
  }, {
    key: "hasHighscore",
    value: function hasHighscore() {
      return _HighscoreService["default"].hasGameHighscore();
    }
  }, {
    key: "setAnswered",
    value: function setAnswered(setId, roundId, questionNumber) {
      var set = this.getGameStatus().sets[setId];
      var round = set.rounds[roundId];

      var _round$getQuestion$se = round.getQuestion(questionNumber).setAnswered(),
          _round$getQuestion$se2 = (0, _slicedToArray2["default"])(_round$getQuestion$se, 2),
          isCorrect = _round$getQuestion$se2[0],
          answered = _round$getQuestion$se2[1];

      if (round.getQuestionCount() > round.nextQuestion + 1) {
        round.nextQuestion += 1;
      } else {
        round.update();
        round.alreadyPlayed = true;
        (0, _QuizService.setRoundPlayed)(round.roundId);

        if (round.passed) {
          (0, _QuizService.postRoundScore)(round.roundId, round.points, round.passed);
          set.addPointsFromRoundToHighscoreList();
          round.status = _RoundObject.ROUND_STATUSES.COMPLETED;
          console.log("set.nextRound: ".concat(String(set.nextRound), " / rounds"));

          if (set.rounds.length > set.nextRound + 1) {
            console.log('setting next round');
            set.nextRound += 1;
          } else {
            set.status = LEVEL_STATUSES.COMPLETED;
          }
        } else {
          round.nextQuestion = 0;
        }

        if (set.nextRound > set.rounds.length) {
          set.nextRound = 0;
        }
      }

      return [isCorrect, answered];
    }
  }]);
  return GamestatusService;
}(_GenericStore2["default"]);

var gameStatusService = new GamestatusService();
var _default = gameStatusService;
exports["default"] = _default;